import request from "@/services/axios";
import pages from "./module/pages"; // 页面
import common from "./module/common"; // 页面
import dataBoard from "./module/dataBoard"; // 页面
import modulePage from "./module/modulePage";
import onlineDict from "./module/onlineDict";
import chartsView from "./module/chartsView";

import projectConfig from '@/core/config';
import label from "./module/label";

// var axiosUrl = window.g.axiosConfig;
// const { url } = axiosUrl;
const url = projectConfig.baseUrl

export { url };
export default {
  ...pages,
  ...common,
  ...dataBoard,
  ...modulePage,
  ...onlineDict,
  ...chartsView,
  ...label,


  // 排产列表
  getWorkOrderSchedulingPage(data) {
    return request({
      url: url + "/WorkOrderScheduling/list",
      method: "post",
      params: data
    });
  },
  // 登录
  login(data, apiUrl) {
    return request({
      url: loginUrl + apiUrl,
      method: "post",
      data: data
    });
  },
  // 注册
  register(data) {
    return request({
      url: url + "/register",
      method: "post",
      data: data
    });
  },
  // 获取企业列表
  getCompanyList(params) {
    return request({
      url: url + "/system/company/list",
      method: "get",
      params: params
    });
  },
  // 打印
  printerImgPrint(data) {
    return request({
      url: "http://192.168.1.113/yx/print/qrcode",
      // url: "http://30.8.1.103/yx/print/qrcode",
      method: "post",
      data: data
    });
  },
  // 跟踪卡批量打印
  batchTrackingCardPrint(data) {
    return request({
      url: url + "admin/productWorkOrder/batchTrackingCardPrint",
      method: "post",
      data: data
    });
  },
  // 产品条码批量打印
  batchProductCodePrint(data) {
    return request({
      url: url + "admin/productWorkOrder/batchProductCodePrint",
      method: "post",
      data: data
    });
  },
  // 生产工单模板导出
  exportProductOrderTemplate(data) {
    return request({
      url: url + "admin/productWorkOrder/exportProductOrderTemplate",
      method: "get",
      responseType: "blob",
      timeout: 1000 * 60 * 10,
    });
  },
  // 打印状态的修改
  batchPrintStatus(data) {
    return request({
      url: url + "admin/productWorkOrder/batchPrintStatus",
      method: "post",
      data: data
    });
    // admin/productWorkOrder/batchPrintStatus
  },
  // 新增品质质检
  addQualityInspect(data) {
    return request({
      url: url + "admin/productWorkOrder/addQualityInspect",
      method: "post",
      data: data
    });
  },
  // 新增报工
  addProduceWorkReport(data) {
    return request({
      url: url + "admin/productWorkOrder/addProduceWorkReport",
      method: "post",
      data: data
    });
  },
  // 新增报工查询
  selectByOrderNoItem(data) {
    return request({
      url: url + "admin/productWorkOrder/selectByOrderNoItem",
      method: "post",
      data: data
    });
  },
  // 新增质检查询
  selectQuality(data) {
    return request({
      url: url + "admin/productWorkOrder/selectQuality",
      method: "post",
      data: data
    });
  },
  // 登录用户角色查询
  selectRole(data) {
    return request({
      url: url + "admin/productWorkOrder/selectRole",
      method: "post",
      data: data
    });
  },
  // 角色id查询对应关系
  selectRelationByRoleId(data) {
    return request({
      url: url + "admin/productWorkOrder/selectRelationByRoleId",
      method: "post",
      params: data
    });
  },
  // pda扫码出入库详情
  selectDetail(data) {
    return request({
      url: url + "admin/productWorkOrder/selectDetail",
      method: "post",
      params: data
    });
  },
  // 新增入库
  addInStorage(data) {
    return request({
      url: url + "admin/productWorkOrder/addInStorage",
      method: "post",
      data: data
    });
  },
  // 新增出库
  addOutStorage(data) {
    return request({
      url: url + "admin/productWorkOrder/addOutStorage",
      method: "post",
      data: data
    });
  },
  // 质检修改并撤回报工
  updateQMS(data) {
    return request({
      url: url + "admin/productWorkOrder/updateQMS",
      method: "post",
      data: data
    });
  },
  // 质检导出数据
  exportQMS(params) {
    return request({
      url: url + "admin/productWorkOrder/exportQMS",
      method: "get",
      responseType: "blob",
      timeout: 1000 * 60 * 10,
      params: params
    });
  },


  // // 登录
  // getLocation(data) {
  //     return request({
  //         url: "https://apis.map.qq.com/ws/location/v1/ip",
  //         method: 'get',
  //         data: data
  //     })
  // },
};
